export const HttpStatus = {
	OK: 200,
	REDIRECT: 302,
	BAD_REQUEST: 400,
	UNAUTHORIZED: 401,
	INTERNAL_SERVER_ERROR: 500,
	GATEWAY_TIMEOUT: 504,
};
